export default __webpack_public_path__ + "proximanova-semiboldit-webfont.woff2";